import { object, string } from "yup"

export const formSchema = object({
  email: string().lowercase().email().trim().required()
})
